import Vue from 'vue'
import toastr from '../toastr'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '../mixins.js'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import moment from 'moment'
import datePicker from '../../component/dccore-form/datePicker.vue'
import NumberInput from '../../component/dccore-form/numberInput.vue'
import Checkbox from '../../component/dccore-form/checkbox.vue'
import History from './history.vue'
// Import this component

if ($('#productionlist_form').length) {
  Vue.use(VueResource)

  new Vue({
    el: '#productionlist_form',
    components: {
      RingLoader,
      Singleselect,
      moment,
      datePicker,
      NumberInput,
      Checkbox,
      History
    },
    mixins: [mixins],
    data: {
      loading: 0,
      entityId: null,
      form: {
        entity: {
          productionDate: moment().format('YYYY-MM-DD'),
          isImported: false,
          source: 'ADDED_MANUALLY',
          isTest: false,
          selectedMeal: null,
          selectedSize: null
        },
        options: {
          errors: {},
          brands: [],
          meals: [],
          sizes: [],
          allSizes: [],
        }
      },
    },
    watch: {
      'form.entity.meal' : function(newVal, oldVal) {
        if (newVal) {
          this.getSizes(newVal)
        }
        if (oldVal) {
          this.form.entity.selectedSize = null
        }
      },
    },
    computed: {
      quantityEditDisabled() {
        return this.form.entity.source !== 'ADDED_MANUALLY'
      }
    },
    mounted: function () {
      Promise.all([
        this.getMeals(),
        this.getBrands(),
      ]).then(() => {
        if ($('#entity_id').length) {
          this.entityId = $('#entity_id').val()
          this.getProductionList()
        }
      })
    },
    methods: {
      createProductionList: function (redirect) {
        let url = Routing.generate('api_post_production_list')
        $('.btn').button('loading')
        Vue.http.post(url, {
          'data': this.form.entity,

        }).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('production_list_grid'))
          } else {
            toastr.success(Translator.trans('form.created'))
          }
          $('.btn').button('reset')
        }, response => {
          $('.btn').button('reset')
          this.handleAjaxError(response, this.form.options)
        })
      },
      updateProductionList: function (redirect) {
        let url = Routing.generate('api_patch_production_list', { id: this.entityId })
        $('.btn').button('loading')
        Vue.http.patch(url, {
          'data': this.form.entity,
        }).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('production_list_grid'))
          } else {
            toastr.success(Translator.trans('form.updated'))
            this.form.options.errors = {}
          }
          $('.btn').button('reset')
        }, response => {
          this.handleAjaxError(response, this.form.options)
          $('.btn').button('reset')
        })
      },
      getProductionList: function () {
        let url = Routing.generate('api_get_production_list', { id: this.entityId,
          context: 'edit' })
        this.loading++
        Vue.http.get(url).then(response => {
          this.form.entity = response.data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getBrands: function () {
        this.loading++
        let url = Routing.generate('api_get_brands', { context: 'dropdown' })

        Vue.http.get(url).then(response => {
          this.form.options.brands = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getMeals: function () {
        this.loading++
        let url = Routing.generate('api_get_meals_by_kind_source', { context: 'dropdown',
          kind:'final_meal', sourceSystem:'erp' })

        Vue.http.get(url).then(response => {
          this.form.options.meals = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getSizes: function(meal) {
        this.loading++
        let url = Routing.generate('api_get_sizes_by_meal', { id: meal,
          context: 'dropdown' })

        Vue.http.get(url).then(response => {
          this.form.options.sizes = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
    },
  })
}
